<template>
  <v-container id="tpvrest" tag="section">
    <base-v-component heading="TPVs restaurante " />
    <base-material-card
      color="indigo"
      icon="mdi-laptop"
      inline
      class="px-5 py-3"
    >
      <!-- <v-toolbar flat color="white">
        <v-btn
          :disabled="disabledGuardarGeneral"
          color="secondary"
          :loading="loadingForm"
          dark
          class="mb-2"
          @click.stop="save()"
          >Guardar</v-btn
        >
        <v-spacer />
      </v-toolbar> -->
      <v-tabs
        vertical
        background-color="deep-purple accent-4"
        center-active
        dark
        v-model="tab"
      >
        <v-tab key="configuracion">Configuración</v-tab>
        <v-tab key="acciones">Acciones</v-tab>

        <v-tab key="cuentas">Cuentas</v-tab>
        <v-tab key="usuarios">Usuarios</v-tab>
        <v-tab key="plano">Plano</v-tab>
        <v-tab key="mesas">Mesas</v-tab>
        <v-tab key="modos">Modos</v-tab>
        <v-tab key="dispositivos">Dispositivos</v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item key="configuracion">
            <v-container>
              <v-toolbar color="grey lighten-2" dense>
                <v-row align="center" class="white--text">
                  <v-btn
                    text
                    @click="guardarConfiguracion"
                    color="primary"
                    :loading="guardarConfiguracionLoading"
                    >Guardar</v-btn
                  >
                  <v-spacer />
                </v-row>
              </v-toolbar>
              <v-row align="center">
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="ZCierre obligatorio"
                    v-model="configuracion.zcierreObligatorio"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Muestra mensajes"
                    v-model="configuracion.muestraMensajes"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Imprime pedidos online local"
                    v-model="configuracion.imprimeOnlineLocal"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Imprime pedidos online Printnode"
                    v-model="configuracion.printNodeExclusivo"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Utilizar printnode de manera exclusiva"
                    v-model="configuracion.printnodeExclusivo"
                    messages="Utilizará el sistema de Printnode, para imprimir cada pedido desde TPV, y anulará el servicio de impresión del TPV. Marcar esta opción si todos los dispositivos se manejarán con printnode"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Utilizar QZ"
                    v-model="configuracion.qz"
                    messages="Activa función QZ.io"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Cashguard"
                    v-model="configuracion.cashguard"
                    messages="Cashguard, solo funciona con QZ"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Filtrar clientes restaurante"
                    v-model="configuracion.clientePorRestaurante"
                    messages="Muestra los clientes solo del restaurante del tpv, no del negocio"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Mostrar motivo eliminar producto"
                    v-model="configuracion.mostrarMotivoEliminarProducto"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    multiple
                    label="Acciones de TPV restringidas "
                    v-model="configuracion.accionesTpvAdminRestriccion"
                    :items="
                      $store.state.restaurantes.accionesTpvAdminRestriccion
                    "
                    messages="Se pedirá confirmación a un usuario admin para realizar esa acción"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    label="Orden categoría / productos"
                    :items="ordenProductosItems"
                    v-model="configuracion.ordenProductos"
                  />
                </v-col>

                <v-col cols="12" md="9">
                  <v-text-field
                    label="API Key Printnode"
                    v-model="configuracion.printnodeApikey"
                    messages="Esta Apikey es por si se agrega una impresora printnode en TPV, no es para la impresión de pedidos online en TPV, eso se hace mediante servidor"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item key="acciones">
            <v-container>
              <v-toolbar color="grey" dense class="mb-4">
                <v-row align="center" class="white--text">
                  ACCIONES
                  <v-spacer />
                </v-row>
              </v-toolbar>
              <v-row>
                <v-col cols="12" md="3">
                  <v-btn @click="reiniciarTpv">REINICIAR</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <v-tab-item key="cuentas">
            <v-container>
              <v-alert dense color="info">Usuarios TPV del restaurante</v-alert>
              <v-toolbar color="grey" dense>
                <v-row align="center" class="white--text">
                  <v-spacer />
                  <v-text-field
                    class="white--text mb-0"
                    v-model="searchCuenta"
                    dense
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                    color="white"
                  ></v-text-field>
                </v-row>
              </v-toolbar>
              <v-data-table
                sort-by="orden"
                disable-sort
                @sorted="saveOrderMesa"
                v-sortable-data-table
                :headers="headersCuentas"
                :items="cuentasTpvComputed"
                :search="searchCuenta"
              >
                <template v-slot:item.marcaConectado="{ item }">
                  <v-row dense align="center" justify="center">
                    <v-col cols="6">
                      <v-tooltip top v-if="marcaConectadoComprobar(item)">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            text
                            color="success"
                            v-on="on"
                            @click="marcaConectado(item, false)"
                          >
                            <v-icon>mdi-star</v-icon>
                          </v-btn>
                        </template>
                        <span>Marca la conexión del restaurante</span>
                      </v-tooltip>
                      <v-tooltip top v-else>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            text
                            color="success"
                            v-on="on"
                            @click="marcaConectado(item, true)"
                          >
                            <v-icon>mdi-star-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>No marca como conexión del restaurante</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="6">
                      <v-tooltip top v-if="cajaEfectivoComprobar(item)">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            text
                            color="success"
                            v-on="on"
                            @click="cajaEfectivo(item, false)"
                          >
                            <v-icon>mdi-currency-eur</v-icon>
                          </v-btn>
                        </template>
                        <span>Tiene caja efectivo</span>
                      </v-tooltip>
                      <v-tooltip top v-else>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            text
                            color="warning"
                            v-on="on"
                            @click="cajaEfectivo(item, true)"
                          >
                            <v-icon>mdi-currency-eur-off</v-icon>
                          </v-btn>
                        </template>
                        <span>No tiene cajón efectivo</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.estado="{ item }">
                  <v-tooltip top v-if="item.state == 'online'">
                    <template v-slot:activator="{ on }">
                      <v-chip color="green" outlined v-on="on">
                        <v-icon>mdi-web</v-icon>
                      </v-chip>
                    </template>
                    <span>Conectado</span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                      <v-chip color="red" outlined v-on="on">
                        <v-icon>mdi-web</v-icon>
                      </v-chip>
                    </template>
                    <span>Desconectado</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.acciones="{ item }">
                  <v-card-actions class="pa-0 ma-0">
                    <v-spacer />
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="success"
                          min-width="0"
                          small
                          @click="editItemDialogCuenta(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </v-card-actions>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item key="usuarios">
            <v-container>
              <v-toolbar color="grey" dense>
                <v-row align="center" class="white--text">
                  <v-btn
                    @click="dialogUsuario = true"
                    class="white--text mb-0"
                    text
                    >AÑADIR USUARIO</v-btn
                  >
                  <v-spacer />
                  <v-text-field
                    class="white--text mb-0"
                    v-model="searchUsuario"
                    dense
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                    color="white"
                  ></v-text-field>
                </v-row>
              </v-toolbar>
              <v-data-table
                :headers="headersUsuario"
                :items="usuariosTpv"
                :search="searchUsuario"
              >
                <template v-slot:item.acciones="{ item }">
                  <v-card-actions class="pa-0 ma-0">
                    <v-spacer />
                    <v-tooltip top v-if="item.activo">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="green"
                          min-width="0"
                          :loading="loadingActivoUsuario"
                          small
                          v-on="on"
                          @click="changeActivoUsuario(item)"
                        >
                          <v-icon small>mdi-check</v-icon>
                        </v-btn>
                      </template>
                      <span>Desactivar</span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          :loading="loadingActivoUsuario"
                          small
                          v-on="on"
                          @click="changeActivoUsuario(item)"
                        >
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Activar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="success"
                          min-width="0"
                          small
                          @click="editItemDialogUsuario(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          :loading="loadingEliminarUsuario"
                          @click="deleteUsuario(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Borrar</span>
                    </v-tooltip>
                  </v-card-actions>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item key="plano">
            <v-toolbar color="primary" dense>
              <v-row align="center">
                <v-toolbar-title class="white--text ml-3"
                  >PLANO TPV</v-toolbar-title
                >
              </v-row>
            </v-toolbar>
            <v-toolbar color="grey" dense>
              <v-row align="center" justify="center" class="white--text">
                <v-btn @click="addObjeto" class="white--text mb-0" text
                  >AÑADIR OBJETO</v-btn
                >
                <v-btn
                  @click="editarObjetoMetodo"
                  class="white--text mb-0 ml-2"
                  :disabled="editarObjetoDisabled"
                  text
                  >EDITAR OBJETO</v-btn
                >

                <v-spacer></v-spacer>
                <v-btn
                  @click="savePlanoTpv"
                  class="secondary mr-5 mb-0"
                  :loading="loadingForm"
                  >Guardar</v-btn
                >
              </v-row>
            </v-toolbar>
            <!-- DISEÑO KONVA -->
            <v-stage
              style="border: 4px solid black"
              :config="configKonva"
              ref="stage"
              @mousedown="handleStageMouseDown"
              @touchstart="handleStageMouseDown"
            >
              <v-layer ref="layer">
                <template v-for="item in listaComputed">
                  <v-group
                    :key="`grupo_${item.id}`"
                    @transformend="handleTransformEnd"
                    @dragend="handleDragEnd($event, item)"
                    :config="item.designGroup"
                    v-if="item.propiedades.figura == 'rect'"
                  >
                    <v-rect :key="item.propiedades.id" :config="item.design" />
                    <v-text
                      :text="item.propiedades.nombre"
                      :key="`texto_${item.id}`"
                      :config="item.designText"
                    />
                  </v-group>
                  <v-group
                    v-if="item.propiedades.figura == 'circle'"
                    :key="`grupo_${item.id}`"
                    @transformend="handleTransformEnd"
                    @dragend="handleDragEnd($event, item)"
                    :config="item.designGroup"
                  >
                    <v-circle :key="item.propiedades.id" :config="item.design">
                    </v-circle>
                    <v-text
                      :text="item.propiedades.nombre"
                      :key="`texto_${item.id}`"
                      :config="item.designText"
                    />
                  </v-group>
                </template>
                <v-transformer ref="transformer" />
              </v-layer>
            </v-stage>
          </v-tab-item>
          <v-tab-item key="mesas">
            <v-container>
              <v-toolbar color="grey" dense>
                <v-row align="center" class="white--text">
                  <v-btn
                    @click="mesaDialog = true"
                    class="white--text mb-0"
                    text
                    >AÑADIR MESA</v-btn
                  >
                  <v-select
                    class="white--text ml-3"
                    :items="modosSelect"
                    v-model="modoMesaFiltrar"
                    label="Agrupación"
                    messages="Seleccione la agrupación de mesas sobre la que filtrar"
                  />
                  <v-spacer />
                  <v-text-field
                    class="white--text mb-0"
                    v-model="searchMesa"
                    dense
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                    color="white"
                  ></v-text-field>
                </v-row>
              </v-toolbar>
              <v-data-table
                :headers="headersMesas"
                :items="mesasTpvFiltradas"
                :search="searchMesa"
                sort-by="orden"
                disable-sort
                :loading="mesasLoading"
                @sorted="saveOrderMesa"
                v-sortable-data-table
              >
                <template v-slot:item.acciones="{ item }">
                  <v-card-actions class="pa-0 ma-0">
                    <v-spacer />
                    <!-- <v-tooltip top v-if="item.activo">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="green"
                          min-width="0"
                          :loading="loadingActivoUsuario"
                          small
                          v-on="on"
                          @click="changeActivoUsuario(item)"
                        >
                          <v-icon small>mdi-check</v-icon>
                        </v-btn>
                      </template>
                      <span>Desactivar</span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          :loading="loadingActivoUsuario"
                          small
                          v-on="on"
                          @click="changeActivoUsuario(item)"
                        >
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Activar</span>
                    </v-tooltip> -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="success"
                          min-width="0"
                          small
                          @click="editItemDialogMesas(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          :loading="mesaEliminarLoading"
                          @click="deleteMesa(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Borrar</span>
                    </v-tooltip>
                  </v-card-actions>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item key="modos">
            <v-container>
              <v-toolbar color="grey" dense>
                <v-row align="center" class="white--text">
                  <v-btn
                    @click="modoDialog = true"
                    class="white--text mb-0"
                    text
                    >AÑADIR MODO</v-btn
                  >
                </v-row>
              </v-toolbar>
              <v-data-table
                :headers="headersModos"
                :items="modosTpv"
                sort-by="orden"
                disable-sort
                @sorted="saveOrderModo"
                v-sortable-data-table
                :loading="modosLoading"
              >
                <template v-slot:item.acciones="{ item }">
                  <v-card-actions class="pa-0 ma-0">
                    <v-spacer />
                    <!-- <v-tooltip top v-if="item.activo">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="green"
                          min-width="0"
                          :loading="loadingActivoUsuario"
                          small
                          v-on="on"
                          @click="changeActivoUsuario(item)"
                        >
                          <v-icon small>mdi-check</v-icon>
                        </v-btn>
                      </template>
                      <span>Desactivar</span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          :loading="loadingActivoUsuario"
                          small
                          v-on="on"
                          @click="changeActivoUsuario(item)"
                        >
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Activar</span>
                    </v-tooltip> -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="success"
                          min-width="0"
                          small
                          @click="editItemDialogModo(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          :loading="modoEliminarLoading"
                          @click="deleteModo(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Borrar</span>
                    </v-tooltip>
                  </v-card-actions>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <v-tab-item key="dispositivos">
            <v-container>
              <v-toolbar color="grey" dense>
                <v-row align="center" class="white--text">
                  <v-btn
                    @click="dispositivoDialog = true"
                    class="white--text mb-0"
                    text
                    >AÑADIR DISPOSITIVO</v-btn
                  >
                  <v-spacer />
                  <v-btn small @click="getDispositivos" text
                    ><v-icon>mdi-reload</v-icon></v-btn
                  >
                </v-row>
              </v-toolbar>
              <v-data-table
                :headers="headersDispositivos"
                :items="dispositivosTpvComputed"
                disable-sort
              >
                <template v-slot:item.acciones="{ item }">
                  <v-card-actions class="pa-0 ma-0">
                    <v-spacer />
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="info"
                          min-width="0"
                          small
                          @click="editDispositivoGeneral(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Configuración dispositivo</span>
                    </v-tooltip>
                    <v-tooltip
                      top
                      v-if="
                        item.tipo == 'impresora' ||
                        item.tipo == 'impresora-printnode' ||
                        item.tipo == 'impresora-qz' ||
                        item.tipo == 'impresora-otro-rest'
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="info"
                          min-width="0"
                          small
                          @click="editDispositivoImpresora(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-printer</v-icon>
                        </v-btn>
                      </template>
                      <span>Configuración impresión</span>
                    </v-tooltip>
                    <v-tooltip top v-if="item.puerto == 'serie'">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="info"
                          min-width="0"
                          small
                          @click="editDispositivoSerie(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-serial-port</v-icon>
                        </v-btn>
                      </template>
                      <span>Configuración serie</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="px-2 ml-1"
                          color="red"
                          min-width="0"
                          small
                          :loading="dispositivosDeleteLoading"
                          @click="deleteDispositivo(item)"
                          v-on="on"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Borrar</span>
                    </v-tooltip>
                  </v-card-actions>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </base-material-card>
    <v-dialog v-model="editarDialog" v-if="editarObjeto" max-width="800">
      <v-card>
        <v-card-title>
          Editar {{ editarObjeto.propiedades.nombre }}
        </v-card-title>
        <v-card-text>
          <h4>Configuración</h4>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field label="Id" v-model="editarObjeto.id" disabled />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                label="Pedible"
                v-model="editarObjeto.propiedades.pedir"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                label="Figura"
                v-model="editarObjeto.propiedades.figura"
                :items="figurasSelect"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Nombre mostrar"
                v-model="editarObjeto.propiedades.nombre"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                :items="$store.state.catalogos.catalogos"
                v-model="editarObjeto.propiedades.catalogo"
                label="Catálogo"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                readonly
                label="Color Fondo"
                v-model="editarObjeto.propiedades.colorFondo.hexa"
              />

              <v-color-picker
                dot-size="25"
                hide-canvas
                hide-inputs
                hide-mode-switch
                hide-sliders
                show-swatches
                swatches-max-height="200"
                label="Color Fondo"
                mode="hexa"
                v-model="editarObjeto.propiedades.colorFondo"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                readonly
                label="Color Texto"
                v-model="editarObjeto.propiedades.colorTexto.hexa"
              />
              <v-color-picker
                dot-size="25"
                hide-canvas
                hide-inputs
                hide-mode-switch
                hide-sliders
                show-swatches
                swatches-max-height="200"
                label="Color Texto"
                mode="hexa"
                v-model="editarObjeto.propiedades.colorTexto"
              />
            </v-col>
          </v-row>
          <v-row v-if="editarObjeto.propiedades.pedir">
            <v-col cols="12" md="2">
              <v-checkbox
                label="Activo"
                v-model="editarObjeto.propiedades.activo"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Comensales"
                type="number"
                step="1"
                v-model="editarObjeto.propiedades.comensales"
              />
            </v-col>
          </v-row>
          <v-card-title> Diseño </v-card-title>
          <!-- {{ editarObjeto }} -->
        </v-card-text>
        <v-card-actions>
          <v-btn color="danger" text @click="eliminarObjeto">Eliminar</v-btn>

          <v-spacer />
          <v-btn @click="editarDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogUsuario" max-width="800">
      <v-card>
        <v-card-title> USUARIO {{ usuarioObjeto.nombre }} </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="usuarioObjeto.nombre" label="Nombre" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="usuarioObjeto.codigo"
                type="number"
                label="Código"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                multiple
                :items="$store.state.restaurantes.usuariosTpvRoles"
                v-model="usuarioObjeto.roles"
                type="number"
                label="Roles"
              />
            </v-col>
            <v-col cols="12" md="6" v-if="usuarioObjeto.roles.includes('tpv')">
              <v-checkbox
                v-model="usuarioObjeto.tpvAdmin"
                label="Es admin TPV"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success"
            @click="saveUsuario"
            :loading="loadingSaveUsuario"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mesaDialog" max-width="800">
      <v-card>
        <v-card-title> MESA {{ mesaObjeto.nombre }} </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field v-model="mesaObjeto.nombre" label="Nombre" />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="mesaObjeto.comensales"
                type="number"
                step="1"
                label="Comensales"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-checkbox
                v-model="mesaObjeto.preguntarComensales"
                label="Preguntar comensales"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="mesaObjeto.modo"
                label="Modo"
                :items="modosSelect"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success"
            @click="saveMesasTpv"
            :loading="mesaSaveLoading"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modoDialog" max-width="800">
      <v-card>
        <v-card-title> MODO {{ modoObjeto.nombre }} </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="modoObjeto.nombre" label="Nombre" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="modoObjeto.imagen" label="Imagen" />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :items="tipoModosDisponibles"
                v-model="modoObjeto.tipoModo"
                label="Tipo de modo"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :items="tarifasItems"
                v-model="modoObjeto.tarifa"
                label="Tarifa"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="modoObjeto.numPedidoRestModoSerie"
                label="Serie modo"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox
                v-model="modoObjeto.mostrarCobrados"
                label="Mostrar cobrados"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox
                v-model="modoObjeto.mostrarEliminados"
                label="Mostrar elimados"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="success" @click="saveModoTpv" :loading="modoSaveLoading"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cuentaDialogo" max-width="800">
      <v-card>
        <v-card-title> CUENTA {{ cuentaObjeto.nombre }} </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="cuentaObjeto.nombre" label="Nombre" />
            </v-col>

            <template v-if="cuentaObjeto.role == 'tpv'">
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.impresionLocal"
                  label="Impresión Local"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.tecladoAsistido"
                  label="Teclado asistido"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.paginacion"
                  label="Paginación"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.bajaCalidad"
                  label="Baja calidad"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.imprimirCocinaAuto"
                  label="Imprimir ticket cocina al cerrar pedido"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.cuentaAtrasCobrado"
                  label="Mostrar cuenta atrás antes de cerrar cobrado"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.comentariosCocinaMuestra"
                  label="Muestra comentarios cocina"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.abreCajonSiempre"
                  label="Abrir cajón al cobrar siempre"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.ocultarDialogoUsuario"
                  label="Ocultar elección de usuario"
                />
              </v-col>
            </template>

            <template v-else-if="cuentaObjeto.role == 'tpv-comandero'">
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.imprimirCocinaAuto"
                  label="Imprimir ticket cocina al cerrar pedido"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="cuentaObjeto.comentariosCocinaMuestra"
                  label="Muestra comentarios cocina"
                />
              </v-col>
            </template>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="cuentaObjeto.ocultarDialogoUsuario"
                label="Ocultar elección de usuario"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success"
            @click="saveCuenta"
            :loading="cuentaSaveLoading"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dispositivoDialog" max-width="800">
      <v-card>
        <v-card-title>
          DISPOSITIVO {{ dispositivoObjeto.nombre }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="dispositivoObjeto.nombre" label="Nombre" />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                :items="dispositivoTipos"
                v-model="dispositivoObjeto.tipo"
                label="Tipo de dispositivo"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="dispositivoObjeto.cuenta"
                label="Cuenta"
                :items="impresionOtroRestCuentaItems"
              />
            </v-col>
            <template v-if="dispositivoObjeto.tipo == 'impresora-printnode'">
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="dispositivoObjeto.printnodeOrdenador"
                  label="Ordenador printnode"
                  :items="ordenadoresPrintnode"
                  item-value="id"
                  item-text="mostrarSelect"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="dispositivoObjeto.printnodeImpresora"
                  label="Impresora printnode"
                  :items="impresorasPrintnode"
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
                v-if="!!dispositivoObjeto.impresionOtroRestRestaurante"
              >
                <v-select
                  v-model="dispositivoObjeto.impresionOtroRestImpresora"
                  label="Impresora a enlazar"
                  :items="dispositivosTpvOtroRestauranteComputed"
                />
              </v-col>
            </template>
            <template v-if="dispositivoObjeto.tipo == 'impresora-qz'">
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="dispositivoObjeto.qzDispositivo"
                  label="Impresora QZ"
                  :items="dispositivosTpvQzComputed"
                  item-value="dispositivo"
                  item-text="nombreMostrar"
                  append-icon="mdi-reload"
                  @click:append="obtenerImpresorasQz"
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
                v-if="!!dispositivoObjeto.impresionOtroRestRestaurante"
              >
                <v-select
                  v-model="dispositivoObjeto.impresionOtroRestImpresora"
                  label="Impresora a enlazar"
                  :items="dispositivosTpvOtroRestauranteComputed"
                />
              </v-col>
            </template>
            <template v-if="dispositivoObjeto.tipo == 'impresora-otro-rest'">
              <v-col cols="12" md="6">
                <v-select
                  v-model="dispositivoObjeto.impresionOtroRestRestaurante"
                  label="Restaurante a enlazar"
                  :items="impresionOtroRestRestaurantesElegir"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="dispositivoObjeto.cuenta"
                  label="Cuenta"
                  :items="impresionOtroRestCuentaItems"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                v-if="!!dispositivoObjeto.impresionOtroRestRestaurante"
              >
                <v-select
                  v-model="dispositivoObjeto.impresionOtroRestImpresora"
                  label="Impresora a enlazar"
                  :items="dispositivosTpvOtroRestauranteComputed"
                />
              </v-col>
            </template>
            <v-col
              cols="12"
              md="6"
              v-if="dispositivoObjeto.tipo == 'ordenador'"
            >
              <v-checkbox
                v-model="dispositivoObjeto.impresionLocal"
                label="Impresión Local"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success"
            @click="saveDispositivo"
            :loading="dispositivoSaveLoading"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dispositivoImpresoraDialog" max-width="800">
      <v-card>
        <v-card-title> DISPOSITIVO {{ dispositivoObjeto.id }} </v-card-title>
        <v-card-text>
          <v-row>
            <v-btn @click="addTicketImpresora" small color="primary"
              >Añadir Ticket impresora</v-btn
            >
          </v-row>
          <v-list>
            <v-list-item
              v-for="(t, i) in dispositivoObjeto.impresiones"
              :key="i"
            >
              <v-list-item-title>
                <v-row align="center">
                  <v-col cols="5">
                    <v-select
                      label="ticket"
                      item-value="id"
                      item-text="nombre"
                      v-model="t.ticket"
                      :items="tickets"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      v-model="t.copias"
                      label="Copias"
                      :items="copias"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      v-model="t.cuentas"
                      label="Filtrar por cuenta"
                      multiple
                      messages="Mandará a imprimir esta cuenta"
                      :items="impresionOtroRestCuentaItems"
                    />
                  </v-col>
                  <v-col cols="1">
                    <v-btn x-small text color="primary" @click="borrarTicket(i)"
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success"
            @click="saveDispositivo"
            :loading="dispositivosSaveLoading"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dispositivoPuertoSerieDialog" max-width="800">
      <v-card>
        <v-card-title>
          DISPOSITIVO {{ dispositivoObjeto.id }} - PUERTO SERIE
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Número de puerto"
                v-model="dispositivoObjeto.numeroPuerto"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="baudRate"
                placeholder="9600"
                v-model="dispositivoObjeto.baudRate"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Parity"
                placeholder="none"
                v-model="dispositivoObjeto.parity"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="dataBits"
                placeholder="1"
                v-model="dispositivoObjeto.dataBits"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="stopBits"
                placeholder="none"
                v-model="dispositivoObjeto.stopBits"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="success"
            @click="saveDispositivo"
            :loading="dispositivosSaveLoading"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import Vue from 'vue';
  import VueKonva from 'vue-konva';
  import Sortable from 'sortablejs';

  Vue.use(VueKonva);
  const width = window.innerWidth;
  const height = window.innerHeight;
  import { mapState, mapGetters } from 'vuex';

  export default {
    data() {
      return {
        //configuracion
        guardarConfiguracionLoading: false,
        configuracion: {
          zcierreObligatorio: false,
          reiniciar: false,
          imprimeOnlineLocal: false,
          imprimeOnlinePrintnode: false,
          muestraMensajes: false,
          printnodeApikey: '',
          qz: false,
        },
        acciones: {
          reiniciar: false,
          comprobarConexion: null,
        },
        // cuentas
        cuentaDialogo: false,
        cuentaSaveLoading: false,
        cuentaObjeto: {
          nombre: '',
          impresionLocal: false,
        },
        //usuarios
        loadingActivoUsuario: false,
        loadingEliminarUsuario: false,
        searchUsuario: '',
        usuarioObjeto: {
          nombre: '',
          roles: [],
          codigo: '',
        },
        mesaObjeto: {
          id: '',
          nombre: '',
          comensales: '',
          modo: '',
          preguntarComensales: false,
        },
        searchMesa: '',
        mesaDialog: false,
        mesaEliminarLoading: false,
        mesaSaveLoading: false,
        dialogUsuario: false,
        loadingSaveUsuario: false,
        headersUsuario: [
          {
            text: 'Nombre',
            value: 'nombre',
          },
          {
            text: 'Roles',
            value: 'roles',
          },
          {
            text: 'Acciones',
            value: 'acciones',
            align: 'right',
          },
        ],
        searchCuenta: '',
        headersCuentas: [
          {
            text: '*',
            value: 'marcaConectado',
          },
          {
            text: 'Estado',
            value: 'estado',
          },
          {
            text: 'Nombre',
            value: 'nombre',
          },
          {
            text: 'Email',
            value: 'email',
          },
          {
            text: 'Rol',
            value: 'role',
          },
          {
            text: 'Version',
            value: 'version',
          },
          {
            text: 'Acciones',
            value: 'acciones',
            align: 'right',
          },
        ],
        headersMesas: [
          {
            text: 'Nombre',
            value: 'nombre',
          },
          {
            text: 'Comensales',
            value: 'comensales',
          },
          {
            text: 'Orden',
            value: 'orden',
          },
          {
            text: 'Acciones',
            value: 'acciones',
            align: 'right',
          },
        ],
        dispositivosTpv: [],
        dispositivosTpvQz: [],
        dispositivosTpvOtroRestaurante: [],
        dispositivoDialog: false,
        dispositivosEliminarLoading: false,
        dispositivosSaveLoading: false,
        dispositivosLoading: false,
        dispositivoSaveLoading: false,
        dispositivoObjeto: {
          id: null,
          nombre: '',
          tipo: '',
        },
        dispositivoImpresoraDialog: false,
        dispositivoPuertoSerieDialog: false,
        modoDialog: false,
        cuentasTpv: [],
        modosTpv: [],
        modoEliminarLoading: false,
        modoSaveLoading: false,
        modosLoading: false,
        mesasLoading: false,
        modoObjeto: {
          id: null,
          nombre: '',
          imagen: '',
          tipoModo: null,
          numPedidoRestModoSerie: 0,
        },
        headersModos: [
          {
            text: 'Nombre',
            value: 'nombre',
          },
          {
            text: 'Imagen',
            value: 'imagen',
          },
          {
            text: 'Orden',
            value: 'orden',
          },
          {
            text: 'Acciones',
            value: 'acciones',
            align: 'right',
          },
        ],
        headersDispositivos: [
          {
            text: 'Nombre',
            value: 'productName',
          },
          {
            text: 'Tipo',
            value: 'tipo',
          },
          {
            text: 'Puerto',
            value: 'puerto',
          },
          {
            text: 'Cuenta',
            value: 'cuenta',
          },
          {
            text: 'Acciones',
            value: 'acciones',
            align: 'right',
          },
        ],
        //fin usuarios
        //konva y plano
        configKonva: {
          width: 1024,
          height: 800,
        },
        loadingForm: false,
        usuariosTpv: [],
        mesasTpv: [],
        objetoAñadirTipo: {
          tipo: null, //estructura, mesa interior, mesa exterior, barra
          nombre: '',
        },
        selectedShapeName: '',
        editarDialog: false,
        editarObjeto: null,
        //fin konva y plano tpv
        lista: [],
        tab: 0,
        tipoModosDisponibles: [
          {
            text: 'Domicilio',
            value: 'domicilio',
          },
          {
            text: 'Recoger',
            value: 'recoger',
          },
          {
            text: 'Mostrador',
            value: 'mostrador',
          },
          {
            text: 'Agrupación de mesas',
            value: 'mesas',
          },
        ],
        modoMesaFiltrar: null,
        dispositivosDeleteLoading: false,
      };
    },
    watch: {
      dispositivoDialog(v) {
        if (!v) {
          this.dispositivoObjeto = {
            id: null,
            nombre: '',
            tipo: '',
          };
        }
      },
      'dispositivoObjeto.impresionOtroRestRestaurante': function () {
        this.getDispositivosEnlazandoRestaurante();
      },
      editarDialog(v) {
        this.$forceUpdate();
        if (!v) {
        }
      },
      dialogUsuario(v) {
        if (!v) {
          this.usuarioObjeto = {
            id: null,
            nombre: '',
            roles: [],
            codigo: '',
          };
        }
      },
      mesaDialog(v) {
        if (!v) {
          this.mesaObjeto = {
            id: '',
            nombre: '',
            comensales: '',
            modo: null,
          };
        }
      },
      modoDialog(v) {
        if (!v) {
          this.modoObjeto = {
            id: null,
            nombre: '',
            imagen: '',
          };
        }
      },
    },
    computed: {
      dispositivosTpvQzComputed() {
        return this.dispositivosTpvQz;
      },

      impresorasPrintnode() {
        return this.$store.state.negocios.impresorasNegocio
          .map((imp) => {
            if (this.dispositivoObjeto.printnodeOrdenador == imp.computer.id) {
              return {
                value: imp.id,
                text: imp.id + '-' + imp.name + '-' + imp.computer.name,
                nombre: imp.name,
                desc: imp.description,
                computerName: imp.computer.name,
                computerId: imp.computer.id,
              };
            }
          })
          .filter((i) => !!i);
      },
      ...mapGetters({
        isAdmin: 'auth/isAdmin',
        ordenadoresPrintnode: 'negocios/getSelectOrdenadores',
      }),
      impresorasQz() {
        return [];
      },
      impresionOtroRestCuentaItems() {
        return this.cuentasTpvComputed.map((t) => {
          return {
            text: t.nombre,
            value: t.email,
          };
        });
      },
      impresionOtroRestRestaurantesElegir() {
        return this.$store.getters['restaurantes/getRestaurantesSelect'].filter(
          (r) => r.value !== this.$store.state.app.restauranteGest
        );
      },
      dispositivosTpvOtroRestauranteComputed() {
        return this.dispositivosTpvOtroRestaurante
          .filter((i) => i.tipo == 'impresora')
          .map((i) => {
            return {
              text: i.productName,
              value: i.productId,
            };
          });
      },
      tarifasItems() {
        return this.$store.state.productos.tarifas.map((t) => {
          return {
            text: t.nombre,
            value: t.id,
          };
        });
      },
      ...mapState({
        tickets: (state) => state.tickets.ticketsArray,
        copias: (state) => state.tickets.copiasArray,
      }),
      dispositivoTipos() {
        return [
          {
            text: 'Impresora',
            value: 'impresora',
          },
          {
            text: 'Impresora Printnode',
            value: 'impresora-printnode',
          },
          {
            text: 'Impresora QZ',
            value: 'impresora-qz',
          },
          {
            text: 'Impresora de otro restaurante',
            value: 'impresora-otro-rest',
          },
          {
            text: 'Balanza',
            value: 'balanza',
          },
          {
            text: 'Ordenador',
            value: 'ordenador',
          },
          {
            text: 'Lector código',
            value: 'lector-codigo',
          },
        ];
      },
      mesasTpvFiltradas() {
        return this.mesasTpv.filter((m) => m.modo == this.modoMesaFiltrar);
      },
      modosSelect() {
        return this.modosTpv
          .filter((m) => m.tipoModo == 'mesas')
          .map((m) => {
            return {
              text: m.nombre,
              value: m.id,
            };
          });
      },
      dispositivosTpvComputed() {
        return this.dispositivosTpv.map((d) => {
          return {
            ...d,
          };
        });
      },
      dispositivosTpvFiltradas() {
        return (
          this.dispositivosTpv
            // .filter((m) => m.tipoModo == "mesas")
            .map((m) => {
              return {
                text: m.nombre,
                value: m.id,
              };
            })
        );
      },
      listaComputed() {
        return this.lista.map((l) => {
          return {
            ...l,
            design: {
              ...l.design,
              fill: l.propiedades.colorFondo
                ? l.propiedades.colorFondo.hexa
                : 'black',
            },
            designText: {
              ...l.designText,
              x: l.design.x,
              y: l.design.y,
            },
          };
        });
      },
      figurasSelect() {
        return [
          {
            text: 'Círculo',
            value: 'circle',
          },
          {
            text: 'Rectángulo',
            value: 'rect',
          },
        ];
      },
      disabledGuardarGeneral() {
        return this.tab == 1;
      },
      editarObjetoDisabled() {
        return this.selectedShapeName.trim().length === 0;
      },
      cuentasTpvComputed() {
        return this.cuentasTpv.map((c) => {
          let f = this.$store.state.app.statusCuentas.find((s) => s.id == c.id);
          return {
            ...c,
            ...(!!f ? f : {}),
          };
        });
      },
    },
    methods: {
      cajaEfectivoComprobar(item) {
        return !!item.marcaCaja;
      },
      cajaEfectivo(i, b) {
        let aux = [...this.cuentasTpv];
        let fI = aux.findIndex((c) => c.id == i.id);
        if (fI > -1) {
          aux[fI].marcaCaja = b;
        }
        this.cuentasTpv = aux;
        this.cuentaObjeto = this.cuentasTpv[fI];
        this.saveCuenta();
      },
      marcaConectadoComprobar(item) {
        return !!item.marcaConectado;
      },
      marcaConectado(i, b) {
        let aux = [...this.cuentasTpv];
        let fI = aux.findIndex((c) => c.id == i.id);
        if (fI > -1) {
          aux[fI].marcaConectado = b;
        }
        this.cuentasTpv = aux;
        this.cuentaObjeto = this.cuentasTpv[fI];
        this.saveCuenta();
      },
      borrarTicket(i) {
        this.dispositivoObjeto.impresiones.splice(i, 1);
      },
      guardarConfiguracion() {
        this.guardarConfiguracionLoading = true;
        this.$store
          .dispatch('restaurantes/guardarConfiguracionTpv', this.configuracion)
          .then(() => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Configuracion guardada',
            });
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar la configuración: ' + error,
            });
          })
          .finally(() => {
            this.guardarConfiguracionLoading = false;
            this.getConfiguracion();
          });
      },
      getConfiguracion() {
        this.$store.dispatch('restaurantes/getConfiguracionTpv').then((r) => {
          console.log(r);
          this.configuracion = r;
        });
      },
      getAcciones() {
        this.$store.dispatch('restaurantes/getAccionesTpv').then((r) => {
          this.acciones = r;
        });
      },
      editItemDialogCuenta(item) {
        this.cuentaDialogo = true;
        this.cuentaObjeto = JSON.parse(JSON.stringify(item));
      },
      editDispositivoGeneral(item) {
        this.dispositivoDialog = true;
        this.dispositivoObjeto = { ...item, nombre: item.productName };
      },
      deleteDispositivo(disp) {
        this.dispositivosDeleteLoading = true;
        this.$store
          .dispatch('restaurantes/deleteDispositivoTpv', disp.id)
          .then(() => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Dispositivo eliminado',
            });
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al eliminar el dispositivo: ' + error,
            });
          })
          .finally(() => {
            this.dispositivosDeleteLoading = false;
            this.dispositivoImpresoraDialog = false;
            this.dispositivoDialog = false;
            this.getDispositivos();
          });
      },
      saveDispositivo() {
        this.dispositivosSaveLoading = true;
        this.$store
          .dispatch('restaurantes/saveDispositivoTpv', {
            ...this.dispositivoObjeto,
            productName: this.dispositivoObjeto.nombre,
            productId: this.dispositivoObjeto.productId
              ? this.dispositivoObjeto.productId
              : null,
          })
          .then(() => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Dispositivo guardado',
            });
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar el dispositivo: ' + error,
            });
          })
          .finally(() => {
            this.dispositivosSaveLoading = false;
            this.dispositivoImpresoraDialog = false;
            this.dispositivoPuertoSerieDialog = false;
            this.dispositivoDialog = false;
            this.getDispositivos();
          });
      },
      addTicketImpresora() {
        this.dispositivoObjeto.impresiones.push({
          ticket: null,
          copias: 1,
          cuentas: null,
        });
      },
      editDispositivoImpresora(item) {
        let aux = {
          ...item,
          impresiones:
            item.impresiones && item.impresiones.length > 0
              ? item.impresiones
              : [],
        };
        this.dispositivoObjeto = { ...aux };
        this.dispositivoImpresoraDialog = true;
      },
      editDispositivoSerie(item) {
        this.dispositivoObjeto = {
          ...item,
        };
        this.dispositivoPuertoSerieDialog = true;
      },
      saveOrderCuentas(event) {
        var copiaMesas = JSON.parse(JSON.stringify(this.mesasTpvFiltradas));
        const movedItem = copiaMesas.splice(event.oldIndex, 1)[0];
        copiaMesas.splice(event.newIndex, 0, movedItem);
        // const movedItem = copiaModos.splice(event.oldIndex, 1)[0];

        // copiaModos.splice(event.newIndex, 0, movedItem);
        // return;
        this.mesasLoading = true;
        Promise.all(
          [...copiaMesas].map((mesa, i) => {
            return this.$store.dispatch('restaurantes/saveMesasTpv', {
              ...mesa,
              orden: i,
            });
          })
        )
          .then(() => this.getMesas())
          .finally(() => (this.mesasLoading = false));

        // this.desserts.splice(event.newIndex, 0, movedItem);
      },
      saveOrderMesa(event) {
        // const movedItem = this.modosTpv[event.oldIndex];
        var copiaMesas = JSON.parse(JSON.stringify(this.mesasTpvFiltradas));
        const movedItem = copiaMesas.splice(event.oldIndex, 1)[0];
        copiaMesas.splice(event.newIndex, 0, movedItem);
        // const movedItem = copiaModos.splice(event.oldIndex, 1)[0];

        // copiaModos.splice(event.newIndex, 0, movedItem);
        // return;
        this.mesasLoading = true;
        Promise.all(
          [...copiaMesas].map((mesa, i) => {
            return this.$store.dispatch('restaurantes/saveMesasTpv', {
              ...mesa,
              orden: i,
            });
          })
        )
          .then(() => this.getMesas())
          .finally(() => (this.mesasLoading = false));

        // this.desserts.splice(event.newIndex, 0, movedItem);
      },
      //modos
      saveOrderModo(event) {
        // const movedItem = this.modosTpv[event.oldIndex];
        var copiaModos = JSON.parse(JSON.stringify(this.modosTpv));
        const movedItem = copiaModos.splice(event.oldIndex, 1)[0];
        copiaModos.splice(event.newIndex, 0, movedItem);
        // const movedItem = copiaModos.splice(event.oldIndex, 1)[0];

        // copiaModos.splice(event.newIndex, 0, movedItem);
        // return;
        this.modosLoading = true;
        Promise.all(
          [...copiaModos].map((modo, i) => {
            return this.$store.dispatch('restaurantes/saveModoTpv', {
              ...modo,
              orden: i,
            });
          })
        )
          .then(() => this.getModos())
          .finally(() => (this.modosLoading = false));

        // this.desserts.splice(event.newIndex, 0, movedItem);
      },
      saveCuenta() {
        this.cuentaSaveLoading = true;
        this.$store
          .dispatch('restaurantes/saveCuentaTpv', this.cuentaObjeto)
          .then(() => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Cuenta guardado',
            });
            this.cuentaDialog = false;
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar la cuenta: ' + error,
            });
          })
          .finally(() => {
            this.cuentaSaveLoading = false;
            this.cuentaDialogo = false;
            this.getCuentas();
          });
      },
      saveModoTpv() {
        this.modoSaveLoading = true;
        this.$store
          .dispatch('restaurantes/saveModoTpv', this.modoObjeto)
          .then(() => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Modo guardado',
            });
            this.mesaDialog = false;
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar el modo: ' + error,
            });
          })
          .finally(() => {
            this.modoSaveLoading = false;
            this.modoDialog = false;
            this.getModos();
          });
      },
      getModos() {
        return this.$store.dispatch('restaurantes/getModosTpv').then((r) => {
          if (r) {
            this.modosTpv = r;
          }
        });
      },
      getCuentas() {
        return this.$store
          .dispatch('restaurantes/getCuentasTpv')
          .then((r) => {
            if (r) {
              this.cuentasTpv = r;
            }

            /*return Promise.all(
            r
              .filter((c) => c.role == "tpv")
              .map((c) => {
                console.log(c);
                return this.$store.dispatch(
                  "restaurantes/getStatusCuenta",
                  c.id
                );
              })
          );*/
          })
          .then((r) => {})
          .catch((e) => console.log(e));
      },
      getDispositivos() {
        return this.$store
          .dispatch('restaurantes/getDispositivosTpv')
          .then((r) => {
            if (r) {
              this.dispositivosTpv = r;
            }
          });
      },
      getDispositivosQz() {
        return this.$store
          .dispatch('restaurantes/getDispositivosTpvQz')
          .then((r) => {
            if (r) {
              console.log(r);
              let res = [];
              r.forEach((disp) => {
                for (let cuenta in disp) {
                  if (cuenta != 'id') {
                    let f = this.cuentasTpvComputed.find((c) => c.id == cuenta);
                    let cuentaMostrar = !!f ? f.nombre : cuenta;
                    disp[cuenta].forEach((element) => {
                      res.push({
                        tipo: disp.id,
                        cuenta: cuenta,
                        dispositivo: element,
                        nombreMostrar:
                          element + ' - ' + cuentaMostrar + ' - ' + disp.id,
                      });
                      console.log(
                        disp.id +
                          ' - cuenta ' +
                          cuenta +
                          ' dispositivo ' +
                          element
                      );
                    });
                  }
                }
              });
              console.log(res);
              this.dispositivosTpvQz = res;
            }
          });
      },

      getDispositivosEnlazandoRestaurante() {
        return this.$store
          .dispatch(
            'restaurantes/getDispositivosTpv',
            this.dispositivoObjeto.impresionOtroRestRestaurante
          )
          .then((r) => {
            if (r) {
              this.dispositivosTpvOtroRestaurante = r;
            }
          });
      },

      //usuarios
      getUsuarios() {
        return this.$store.dispatch('restaurantes/getUsuariosTpv').then((r) => {
          if (r) {
            this.usuariosTpv = r;
          }
        });
      },
      saveMesasTpv() {
        this.mesaSaveLoading = true;
        this.$store
          .dispatch('restaurantes/saveMesasTpv', this.mesaObjeto)
          .then(() => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Mesa guardada',
            });
            this.mesaDialog = false;
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar la mesa: ' + error,
            });
          })
          .finally(() => {
            this.mesaSaveLoading = false;
            this.mesaDialog = false;
            this.getMesas();
          });
      },
      getMesas() {
        return this.$store.dispatch('restaurantes/getMesasTpv').then((r) => {
          if (r) {
            this.mesasTpv = r;
          }
        });
      },
      saveUsuario() {
        this.loadingSaveUsuario = true;
        this.$store
          .dispatch('restaurantes/saveUsuarioTpv', this.usuarioObjeto)
          .then(() => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Usuario guardado',
            });
            this.dialogUsuario = false;
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar el usuario: ' + error,
            });
          })
          .finally(() => {
            this.loadingSaveUsuario = false;
            this.getUsuarios();
          });
      },
      editItemDialogUsuario(item) {
        this.usuarioObjeto = JSON.parse(JSON.stringify(item));
        this.dialogUsuario = true;
      },
      editItemDialogMesas(item) {
        this.mesaObjeto = JSON.parse(JSON.stringify(item));
        this.mesaDialog = true;
      },
      editItemDialogModo(item) {
        this.modoObjeto = JSON.parse(JSON.stringify(item));
        this.modoDialog = true;
      },
      changeActivoUsuario(item) {
        this.loadingActivoUsuario = true;
        this.$store
          .dispatch('restaurantes/changeActivoUsuarioTpv', item)
          .then((res) => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Usuario cambiado',
            });
            return this.getUsuarios();
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al cambiar el usuario',
            });
          })
          .finally(() => {
            this.loadingActivoUsuario = false;
          });
      },
      deleteUsuario(item) {
        var confirm = false;
        this.$confirm(
          '¿Desea eliminar el usuario TPV? Esta acción es irreversible',
          {
            buttonTrueText: 'Aceptar',
            buttonFalseText: 'No',
            color: 'warning',
            icon: 'warning',
            width: 350,
          }
        )
          .then((r) => {
            if (r) {
              confirm = true;
              this.loading = true;
              this.loadingEliminarUsuario = true;
              return this.$store.dispatch(
                'restaurantes/deleteUsuarioTpv',
                item.id
              );
            }
          })
          .then((res) => {
            if (confirm) {
              this.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Usuario eliminado',
              });
              this.getUsuarios();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al eliminar ' + error,
            });
          })
          .finally(() => {
            this.loading = false;
            this.loadingEliminarUsuario = false;
          });
      },
      deleteMesa(item) {
        var confirm = false;
        this.$confirm(
          '¿Desea eliminar la mesa TPV? Esta acción es irreversible',
          {
            buttonTrueText: 'Aceptar',
            buttonFalseText: 'No',
            color: 'warning',
            icon: 'warning',
            width: 350,
          }
        )
          .then((r) => {
            if (r) {
              confirm = true;
              this.loading = true;
              this.mesaEliminarLoading = true;
              return this.$store.dispatch(
                'restaurantes/deleteMesaTpv',
                item.id
              );
            }
          })
          .then((res) => {
            if (confirm) {
              this.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Mesa eliminada',
              });
              this.getMesas();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al eliminar ' + error,
            });
          })
          .finally(() => {
            this.loading = false;
            this.mesaEliminarLoading = false;
          });
      },
      deleteModo(item) {
        var confirm = false;
        this.$confirm(
          '¿Desea eliminar el modo TPV? Esta acción es irreversible',
          {
            buttonTrueText: 'Aceptar',
            buttonFalseText: 'No',
            color: 'warning',
            icon: 'warning',
            width: 350,
          }
        )
          .then((r) => {
            if (r) {
              confirm = true;
              this.loading = true;
              this.mesaEliminarLoading = true;
              return this.$store.dispatch(
                'restaurantes/deleteModoTpv',
                item.id
              );
            }
          })
          .then((res) => {
            if (confirm) {
              this.$store.commit('snackbar/setMensajeSuccess', {
                msj: 'Modo eliminada',
              });
              this.getModos();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al eliminar ' + error,
            });
          })
          .finally(() => {
            this.loading = false;
            this.mesaEliminarLoading = false;
          });
      },
      //konga y sección tpv
      handleDragEnd(e, item) {
        //   console.log(item);
        //   console.log(e);
        //   console.log(e.target.attrs.x);
        //   console.log(e.target.attrs.y);
        let fIndex = this.lista.findIndex((l) => l.id === item.id);
        if (fIndex > -1) {
          this.lista[fIndex].designGroup.x = e.currentTarget.attrs.x;
          this.lista[fIndex].designGroup.y = e.currentTarget.attrs.y;
        }
      },
      handleTransformEnd(e) {
        // shape is transformed, let us save new attrs back to the node
        // find element in our state
        const fIndex = this.lista.findIndex(
          (r) => r.id === this.selectedShapeName
        );
        this.lista[fIndex].designGroup.x = e.target.x();
        this.lista[fIndex].designGroup.y = e.target.y();
        this.lista[fIndex].designGroup.rotation = e.target.rotation();
        this.lista[fIndex].designGroup.scaleX = e.target.scaleX();
        this.lista[fIndex].designGroup.scaleY = e.target.scaleY();
        // update the state
        //   rect.x = e.target.x();
        //   rect.y = e.target.y();
        //   rect.rotation = e.target.rotation();
        //   rect.scaleX = e.target.scaleX();
        //   rect.scaleY = e.target.scaleY();
        //   // change fill
        //   rect.fill = Konva.Util.getRandomColor();
      },
      handleStageMouseDown(e) {
        // clicked on stage - clear selection
        if (e.target === e.target.getStage()) {
          this.selectedShapeName = '';
          this.updateTransformer();
          return;
        }
        // clicked on transformer - do nothing
        const clickedOnTransformer =
          e.target.getParent().className === 'Transformer';
        if (clickedOnTransformer) {
          return;
        }

        // find clicked rect by its name
        const name = e.target.name();
        const rect = this.lista.find((r) => r.id === name);

        if (rect) {
          this.selectedShapeName = name;
        } else {
          this.selectedShapeName = '';
        }
        this.updateTransformer();
      },
      updateTransformer() {
        // here we need to manually attach or detach Transformer node
        const transformerNode = this.$refs.transformer.getNode();
        const stage = transformerNode.getStage();
        const { selectedShapeName } = this;

        const selectedNode = stage.findOne('.' + selectedShapeName);
        // do nothing if selected node is already attached
        if (selectedNode === transformerNode.node()) {
          return;
        }

        if (selectedNode) {
          // attach to another node
          transformerNode.nodes([selectedNode]);
        } else {
          // remove transformer
          transformerNode.nodes([]);
        }
        transformerNode.getLayer().batchDraw();
      },
      //fin konga
      addObjeto() {
        let id = Date.now().toString();
        this.lista.push({
          id: id,
          design: {
            rotation: 0,
            x: 100,
            y: 100,
            width: 100,
            height: 100,
            scaleX: 1,
            scaleY: 1,
            fill: 'red',
            name: id,
            draggable: false,
          },
          designText: {
            name: id,
            x: 100,
            y: 100,
            scaleX: 1,
            scaleY: 1,
            fill: '000000',
            draggable: false,
          },
          designGroup: {
            rotation: 0,
            x: 100,
            y: 100,
            width: 100,
            height: 100,
            scaleX: 1,
            scaleY: 1,
            fill: 'yellow',
            name: id,
            draggable: true,
          },
          propiedades: {
            figura: 'circle',
            activo: true,
            pedir: true,
            colorFondo: { hexa: '#FFFFFFF' },
            colorTexto: { hexa: '#FFFFFFF' },
            nombre: '',
          },
        });
      },
      eliminarObjeto() {
        var index = this.lista.findIndex((l) => l.id === this.editarObjeto.id);
        if (index > -1) {
          this.lista.splice(index, 1);
          this.editarDialog = false;
          this.selectedShapeName = '';
          this.updateTransformer();
        }
      },
      editarObjetoMetodo() {
        this.editarObjeto = this.lista.find(
          (l) => l.id == this.selectedShapeName
        );
        if (!this.editarObjeto.propiedades.colorFondo) {
          this.editarObjeto.propiedades.colorFondo = { hexa: '#FFFFFFF' };
          this.editarObjeto.propiedades.colorTexto = { hexa: '#FFFFFFF' };
        }
        this.editarDialog = true;
      },
      savePlanoTpv() {
        this.loadingForm = true;
        this.$store
          .dispatch('restaurantes/savePlanoTpv', this.lista)
          .then(() => {
            this.$store.commit('snackbar/setMensajeSuccess', {
              msj: 'Plano guardado',
            });
          })
          .catch((error) => {
            this.$store.commit('snackbar/setMensajeDanger', {
              msj: 'Error al guardar el plano: ' + error,
            });
          })
          .finally(() => {
            this.loadingForm = false;
          });
      },
      reiniciarTpv() {
        this.$store.dispatch('restaurantes/saveAccionesTpv', {
          reiniciar: true,
        });
      },
      obtenerImpresorasQz() {
        this.getDispositivosQz().then(() => {
          return this.$store
            .dispatch('restaurantes/saveAccionesTpv', {
              obtenerImpresorasQz: true,
            })
            .then(() => {
              setTimeout(() => {
                console.log('volvemos a obtener');
                this.getDispositivosQz();
              }, 4000);
            });
        });
      },
      //
    },
    directives: {
      sortableDataTable: {
        bind(el, binding, vnode) {
          const options = {
            animation: 150,
            onUpdate: function (event) {
              vnode.child.$emit('sorted', event);
            },
          };
          Sortable.create(el.getElementsByTagName('tbody')[0], options);
        },
      },
    },
    mounted() {
      this.$store.dispatch('restaurantes/getPlanoTpv').then((r) => {
        if (r) {
          this.lista = r.plano1;
        }
      });
      this.modoMesaFiltrar =
        this.modosSelect.length > 0 ? this.modosSelect[0] : null;
      this.getUsuarios();
      this.getMesas();
      this.getModos();
      this.getCuentas();
      this.getDispositivos();
      this.getConfiguracion();
      this.getAcciones();
    },
  };
</script>

<style></style>
